import { LABELS } from "~/resources/Labels";
import { SIMPLDialog } from "../../components/commons/dialog/SimplDialog";
import { getCloudProviderName } from "~/Utils/Utils";
import { FormCloudEnvironmentResponse } from "~/models/Commons ";
import { DetailRow } from "../DetailsRow/DetailsRow";


interface DetailProps {
  item: FormCloudEnvironmentResponse;
  onClose: () => void;
}

export const DetailViewCloudProvisioner = ({
  item,
  onClose,
}: DetailProps) => {
  return (
    <SIMPLDialog onCloseModal={onClose} title={LABELS.DetailView}>
      <div className="w-auto p-2 pb-5 flex flex-col">
        <DetailRow label="Name" value={item.environmentName} />
        <DetailRow
          label="Description"
          value={item.environmentDescription}
        />
        <DetailRow
          label="DataCenter Name"
          value={item.datacenterName}
        />
        <DetailRow
          label="DataCenter Description"
          value={item.datacenterDescription}
        />
        <DetailRow
          label={LABELS.Provider}
          value={getCloudProviderName(item.cloudProvider)}
        />
        <DetailRow
          label={LABELS.Location}
          value={item.location}
        />
        <DetailRow
          label="Iac"
          value={item.iac}
          className="truncate"
        />
      </div>
    </SIMPLDialog>
  );
};
